// extracted by mini-css-extract-plugin
export default {"work":"Work_work__7erzn","container":"Work_container__jeBfG","highlight":"Work_highlight__Bu26b","title":"Work_title__k2RCv"};